import { Injectable } from '@angular/core';
@Injectable()
export class ColorProvider {
  static getColorValue(color: string) {
    return window
      .getComputedStyle(document.body)
      .getPropertyValue(color)
      .trim();
  }
}



// WEBPACK FOOTER //
// ./src/providers/color/color.ts